import React from 'react';

const Logo = ({ className = "w-10 h-10" }) => (
  <svg 
    viewBox="0 0 100 100" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
    className={`shrink-0 ${className}`}
  >
    {/* Clean gradient waveform combining 'D' and 'C' forms */}
    <defs>
      <linearGradient id="dc-grad" x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#818CF8" /> {/* Indigo 400 */}
        <stop offset="100%" stopColor="#4F46E5" /> {/* Indigo 600 */}
      </linearGradient>
      <linearGradient id="dc-grad-dark" x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#1C1917" />
        <stop offset="100%" stopColor="#292524" />
      </linearGradient>
    </defs>
    
    {/* Base Shape: Elegant dark squircle but smaller, or just the raw SVG icon? 
        The nav uses w-10 h-10. Let's make an elegant 3D-ish folded C / D shape. */}
    <rect width="100" height="100" rx="22" fill="url(#dc-grad-dark)" className="shadow-lg" />
    
    {/* A highly polished geometric D/C overlapping shape */}
    <path 
      d="M35 25 H55 C70 25 80 35 80 50 C80 65 70 75 55 75 H35 V25 Z" 
      fill="url(#dc-grad)" 
    />
    <path 
      d="M35 40 H50 C58 40 62 45 62 50 C62 55 58 60 50 60 H35 V40 Z" 
      fill="#ffffff" 
    />
    
    {/* Audio Wave cutouts indicating captions/audio */}
    <rect x="25" y="42" width="6" height="16" rx="3" fill="#A5B4FC" />
    <rect x="15" y="46" width="6" height="8" rx="3" fill="#A5B4FC" />
  </svg>
);

export default Logo;
